import { useEffect, useState } from "react";
import MainPageSection from "components/Layout/MainPageSection";
import CustomHeading from "components/UIComponents/Typography/Heading";
import { FormattedMessage } from "react-intl";
import NewsBlockItem from "../NewsBlockItem";
import "./NewsBlock.css";
import { Link } from "react-router-dom";
import { Center, Text } from "@chakra-ui/react";
import { GetNews } from "api/GetNews";
import { sortNewsByLatest } from "utils/news/sortNewsByLatest";

const NewsBlock = () => {
  const [newsList, setNewsList] = useState([]);

  useEffect(() => {
    if (!newsList.length) {
      GetNews().then(({ data }) => {
        const sortednews = sortNewsByLatest(data.data.articles);
        setNewsList(sortednews);
      });
    }
  }, [newsList.length]);

  return (
    <MainPageSection>
      <CustomHeading className="section-heading">
        <FormattedMessage id="MainPageNewsHeading" />
      </CustomHeading>
      <section className="news-items-wrapper">
        {!!newsList.length &&
          newsList.map(
            (item, index) =>
              index <= 3 && <NewsBlockItem key={item.id} item={item} />
          )}
      </section>
      <Center mt="15px">
        <Link to="/news-all" className="news-item-link">
          <Text colorScheme="blue" fontSize="xl">
            See all news
          </Text>
        </Link>
      </Center>
    </MainPageSection>
  );
};

export default NewsBlock;